import _ from 'lodash';
import {flattenObject} from '../../../util/helpers';
export const PAGE_LOADED = 'hg/dataLayer/PAGE_LOADED';
export const ANALYTICS_DATA_RECEIVED = 'hg/dataLayer/ANALYTICS_DATA_RECEIVED';
export const ANALYTICS_ERRORS_RECEIVED = 'hg/dataLayer/ANALYTICS_ERRORS_RECEIVED';
export const CUSTOM_EVENT_RECEIVED = 'hg/dataLayer/CUSTOM_EVENT_RECEIVED';

const initialState = {

};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case PAGE_LOADED:
      return {
        ...state,
        ...action.payload
      };

    case ANALYTICS_DATA_RECEIVED:
    return {
      ...state,
      ...action.payload
    };

    case ANALYTICS_ERRORS_RECEIVED:
    return {
      ...state,
      ...action.payload
    };

    case CUSTOM_EVENT_RECEIVED:
    return {
      ...state,
      ...action.payload
    };

    default:
      return state;
  }
};

export const logFormErrors = errors => {
  const flatErrors = flattenObject(errors);
  const errorMessages = _.values(flatErrors);

  return {
    type:ANALYTICS_ERRORS_RECEIVED,
    payload: {errorMessages}
  };
};

export const logCustomEvent = eventContent => {
  return {
    type:CUSTOM_EVENT_RECEIVED,
    payload: {eventContent}
  };
};

export const logUserClick = eventContent => {
  return logCustomEvent({
    type: "click",
    eventName: "button click",
    ...eventContent
  });
};



/** WEBPACK FOOTER **
 ** ./client/redux/modules/dataLayer/dataLayer.js
 **/